<div class="modal-header"><h2 class="modal-title">Offering Schedule</h2></div>
<div class="modal-body">
  @if (offeringSchedule) {
    <div>
      <dx-form [formData]="offeringSchedule" validationGroup="validationGroup">
        <dxi-item dataField="offeringDate"></dxi-item>
        @if (specialAccounts) {
          <dxi-item [label]="{ text: 'Special Accounts' }">
            <div *dxTemplate>
              <dx-select-box [(value)]="offeringSchedule.specialAccountId" [items]="specialAccounts" valueExpr="id" displayExpr="name"> </dx-select-box>
            </div>
            <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
            <dxi-validation-rule type="range" [min]="'1'" message="Required"> </dxi-validation-rule>
          </dxi-item>
        }
        @if (offeringSchedule) {
          <dxi-item [label]="{ text: 'AM Offering' }">
            <div *dxTemplate>
              <dx-check-box [(value)]="offeringSchedule.aMOffering" (onValueChanged)="aMChange($event)">
                @if (!offeringSchedule.pMOffering) {
                  <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                }
              </dx-check-box>
            </div>
            @if (!offeringSchedule.pMOffering) {
              <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
            }
          </dxi-item>
        }
        @if (offeringSchedule) {
          <dxi-item [label]="{ text: 'PM Offering' }">
            <div *dxTemplate>
              <dx-check-box [(value)]="offeringSchedule.pMOffering" (onValueChanged)="pMChange($event)"> </dx-check-box>
            </div>
            @if (!offeringSchedule.aMOffering) {
              <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
            }
          </dxi-item>
        }
        <dxi-item [label]="{ text: 'Note' }">
          <div *dxTemplate><dx-text-area [(value)]="offeringSchedule.note" [height]="100"></dx-text-area></div>
        </dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
